/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  HoundsMinter,
  HoundsMinterInterface,
  Constructor,
} from "../HoundsMinter";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "symbol",
            type: "string",
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: "uint256",
                    name: "staminaLastUpdate",
                    type: "uint256",
                  },
                  {
                    internalType: "uint32",
                    name: "staminaValue",
                    type: "uint32",
                  },
                ],
                internalType: "struct Hound.Stamina",
                name: "stamina",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "uint256",
                    name: "lastBreed",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "externalBreedingFee",
                    type: "uint256",
                  },
                  {
                    internalType: "bool",
                    name: "availableToBreed",
                    type: "bool",
                  },
                ],
                internalType: "struct Hound.Breeding",
                name: "breeding",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "uint256",
                    name: "maleParent",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "femaleParent",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "generation",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "birthDate",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "specie",
                    type: "uint256",
                  },
                  {
                    internalType: "uint32[72]",
                    name: "geneticSequence",
                    type: "uint32[72]",
                  },
                  {
                    internalType: "string",
                    name: "extensionTraits",
                    type: "string",
                  },
                ],
                internalType: "struct Hound.Identity",
                name: "identity",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "string",
                    name: "name",
                    type: "string",
                  },
                  {
                    internalType: "string",
                    name: "token_uri",
                    type: "string",
                  },
                  {
                    internalType: "uint256",
                    name: "runningOn",
                    type: "uint256",
                  },
                  {
                    internalType: "bool",
                    name: "custom",
                    type: "bool",
                  },
                ],
                internalType: "struct Hound.Profile",
                name: "profile",
                type: "tuple",
              },
            ],
            internalType: "struct Hound.Struct",
            name: "defaultHound",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "address",
                name: "externalBreedingFeeCurrency",
                type: "address",
              },
              {
                internalType: "address",
                name: "breedingCooldownCurrency",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "breedingCooldown",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "breedingCooldownTimeUnit",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "refillBreedingCooldownCost",
                type: "uint256",
              },
            ],
            internalType: "struct Hound.ConstructorBreeding",
            name: "breeding",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "address",
                name: "staminaRefillCurrency",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "staminaRefill1x",
                type: "uint256",
              },
              {
                internalType: "uint32",
                name: "staminaPerTimeUnit",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "staminaCap",
                type: "uint32",
              },
            ],
            internalType: "struct Hound.ConstructorStamina",
            name: "stamina",
            type: "tuple",
          },
          {
            internalType: "address[]",
            name: "operators",
            type: "address[]",
          },
          {
            internalType: "bytes4[][]",
            name: "targets",
            type: "bytes4[][]",
          },
          {
            components: [
              {
                internalType: "address",
                name: "restricted",
                type: "address",
              },
              {
                internalType: "address",
                name: "minter",
                type: "address",
              },
              {
                internalType: "address",
                name: "houndsModifier",
                type: "address",
              },
              {
                internalType: "address",
                name: "zerocost",
                type: "address",
              },
              {
                internalType: "address",
                name: "hounds",
                type: "address",
              },
              {
                internalType: "address",
                name: "payments",
                type: "address",
              },
              {
                internalType: "address",
                name: "shop",
                type: "address",
              },
              {
                internalType: "address",
                name: "races",
                type: "address",
              },
              {
                internalType: "address",
                name: "genetics",
                type: "address",
              },
              {
                internalType: "address",
                name: "houndsInitializer",
                type: "address",
              },
              {
                internalType: "address",
                name: "houndsRenameHandler",
                type: "address",
              },
            ],
            internalType: "struct ConstructorBoilerplate.Struct",
            name: "boilerplate",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "address",
                name: "renameFeeCurrency",
                type: "address",
              },
              {
                internalType: "address",
                name: "platformBreedFeeCurrency",
                type: "address",
              },
              {
                internalType: "address",
                name: "breedTransactionFeeCurrency",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "platformBreedFee",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "breedTransactionFee",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "renameFee",
                type: "uint256",
              },
            ],
            internalType: "struct ConstructorFees.Struct",
            name: "fees",
            type: "tuple",
          },
        ],
        internalType: "struct Constructor.Struct",
        name: "input",
        type: "tuple",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "parent1",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "parent2",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        components: [
          {
            components: [
              {
                internalType: "uint256",
                name: "staminaLastUpdate",
                type: "uint256",
              },
              {
                internalType: "uint32",
                name: "staminaValue",
                type: "uint32",
              },
            ],
            internalType: "struct Hound.Stamina",
            name: "stamina",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "lastBreed",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "externalBreedingFee",
                type: "uint256",
              },
              {
                internalType: "bool",
                name: "availableToBreed",
                type: "bool",
              },
            ],
            internalType: "struct Hound.Breeding",
            name: "breeding",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "maleParent",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "femaleParent",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "generation",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "birthDate",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "specie",
                type: "uint256",
              },
              {
                internalType: "uint32[72]",
                name: "geneticSequence",
                type: "uint32[72]",
              },
              {
                internalType: "string",
                name: "extensionTraits",
                type: "string",
              },
            ],
            internalType: "struct Hound.Identity",
            name: "identity",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "string",
                name: "name",
                type: "string",
              },
              {
                internalType: "string",
                name: "token_uri",
                type: "string",
              },
              {
                internalType: "uint256",
                name: "runningOn",
                type: "uint256",
              },
              {
                internalType: "bool",
                name: "custom",
                type: "bool",
              },
            ],
            internalType: "struct Hound.Profile",
            name: "profile",
            type: "tuple",
          },
        ],
        indexed: false,
        internalType: "struct Hound.Struct",
        name: "offspring",
        type: "tuple",
      },
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "BreedHound",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "status",
        type: "bool",
      },
    ],
    name: "HoundBreedable",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "status",
        type: "bool",
      },
    ],
    name: "HoundBreedingStatusUpdate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "queueId",
        type: "uint256",
      },
    ],
    name: "HoundQueueStatusUpdate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "stamina",
        type: "uint32",
      },
    ],
    name: "HoundStaminaUpdate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        components: [
          {
            components: [
              {
                internalType: "uint256",
                name: "staminaLastUpdate",
                type: "uint256",
              },
              {
                internalType: "uint32",
                name: "staminaValue",
                type: "uint32",
              },
            ],
            internalType: "struct Hound.Stamina",
            name: "stamina",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "lastBreed",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "externalBreedingFee",
                type: "uint256",
              },
              {
                internalType: "bool",
                name: "availableToBreed",
                type: "bool",
              },
            ],
            internalType: "struct Hound.Breeding",
            name: "breeding",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "maleParent",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "femaleParent",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "generation",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "birthDate",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "specie",
                type: "uint256",
              },
              {
                internalType: "uint32[72]",
                name: "geneticSequence",
                type: "uint32[72]",
              },
              {
                internalType: "string",
                name: "extensionTraits",
                type: "string",
              },
            ],
            internalType: "struct Hound.Identity",
            name: "identity",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "string",
                name: "name",
                type: "string",
              },
              {
                internalType: "string",
                name: "token_uri",
                type: "string",
              },
              {
                internalType: "uint256",
                name: "runningOn",
                type: "uint256",
              },
              {
                internalType: "bool",
                name: "custom",
                type: "bool",
              },
            ],
            internalType: "struct Hound.Profile",
            name: "profile",
            type: "tuple",
          },
        ],
        indexed: false,
        internalType: "struct Hound.Struct",
        name: "hound",
        type: "tuple",
      },
    ],
    name: "NewHound",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "string",
            name: "proposal",
            type: "string",
          },
          {
            internalType: "bool",
            name: "accepted",
            type: "bool",
          },
          {
            internalType: "bool",
            name: "sessionActive",
            type: "bool",
          },
        ],
        indexed: false,
        internalType: "struct RenamingProposal.Struct",
        name: "renameProposal",
        type: "tuple",
      },
    ],
    name: "RenameProposal",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "hound1",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "hound2",
        type: "uint256",
      },
    ],
    name: "breedHounds",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "control",
    outputs: [
      {
        internalType: "string",
        name: "name",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol",
        type: "string",
      },
      {
        components: [
          {
            components: [
              {
                internalType: "uint256",
                name: "staminaLastUpdate",
                type: "uint256",
              },
              {
                internalType: "uint32",
                name: "staminaValue",
                type: "uint32",
              },
            ],
            internalType: "struct Hound.Stamina",
            name: "stamina",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "lastBreed",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "externalBreedingFee",
                type: "uint256",
              },
              {
                internalType: "bool",
                name: "availableToBreed",
                type: "bool",
              },
            ],
            internalType: "struct Hound.Breeding",
            name: "breeding",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "maleParent",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "femaleParent",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "generation",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "birthDate",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "specie",
                type: "uint256",
              },
              {
                internalType: "uint32[72]",
                name: "geneticSequence",
                type: "uint32[72]",
              },
              {
                internalType: "string",
                name: "extensionTraits",
                type: "string",
              },
            ],
            internalType: "struct Hound.Identity",
            name: "identity",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "string",
                name: "name",
                type: "string",
              },
              {
                internalType: "string",
                name: "token_uri",
                type: "string",
              },
              {
                internalType: "uint256",
                name: "runningOn",
                type: "uint256",
              },
              {
                internalType: "bool",
                name: "custom",
                type: "bool",
              },
            ],
            internalType: "struct Hound.Profile",
            name: "profile",
            type: "tuple",
          },
        ],
        internalType: "struct Hound.Struct",
        name: "defaultHound",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "externalBreedingFeeCurrency",
            type: "address",
          },
          {
            internalType: "address",
            name: "breedingCooldownCurrency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "breedingCooldown",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "breedingCooldownTimeUnit",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "refillBreedingCooldownCost",
            type: "uint256",
          },
        ],
        internalType: "struct Hound.ConstructorBreeding",
        name: "breeding",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "staminaRefillCurrency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "staminaRefill1x",
            type: "uint256",
          },
          {
            internalType: "uint32",
            name: "staminaPerTimeUnit",
            type: "uint32",
          },
          {
            internalType: "uint32",
            name: "staminaCap",
            type: "uint32",
          },
        ],
        internalType: "struct Hound.ConstructorStamina",
        name: "stamina",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "restricted",
            type: "address",
          },
          {
            internalType: "address",
            name: "minter",
            type: "address",
          },
          {
            internalType: "address",
            name: "houndsModifier",
            type: "address",
          },
          {
            internalType: "address",
            name: "zerocost",
            type: "address",
          },
          {
            internalType: "address",
            name: "hounds",
            type: "address",
          },
          {
            internalType: "address",
            name: "payments",
            type: "address",
          },
          {
            internalType: "address",
            name: "shop",
            type: "address",
          },
          {
            internalType: "address",
            name: "races",
            type: "address",
          },
          {
            internalType: "address",
            name: "genetics",
            type: "address",
          },
          {
            internalType: "address",
            name: "houndsInitializer",
            type: "address",
          },
          {
            internalType: "address",
            name: "houndsRenameHandler",
            type: "address",
          },
        ],
        internalType: "struct ConstructorBoilerplate.Struct",
        name: "boilerplate",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "address",
            name: "renameFeeCurrency",
            type: "address",
          },
          {
            internalType: "address",
            name: "platformBreedFeeCurrency",
            type: "address",
          },
          {
            internalType: "address",
            name: "breedTransactionFeeCurrency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "platformBreedFee",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "breedTransactionFee",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "renameFee",
            type: "uint256",
          },
        ],
        internalType: "struct ConstructorFees.Struct",
        name: "fees",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "houndId",
        type: "uint256",
      },
    ],
    name: "hound",
    outputs: [
      {
        components: [
          {
            components: [
              {
                internalType: "uint256",
                name: "staminaLastUpdate",
                type: "uint256",
              },
              {
                internalType: "uint32",
                name: "staminaValue",
                type: "uint32",
              },
            ],
            internalType: "struct Hound.Stamina",
            name: "stamina",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "lastBreed",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "externalBreedingFee",
                type: "uint256",
              },
              {
                internalType: "bool",
                name: "availableToBreed",
                type: "bool",
              },
            ],
            internalType: "struct Hound.Breeding",
            name: "breeding",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "uint256",
                name: "maleParent",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "femaleParent",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "generation",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "birthDate",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "specie",
                type: "uint256",
              },
              {
                internalType: "uint32[72]",
                name: "geneticSequence",
                type: "uint32[72]",
              },
              {
                internalType: "string",
                name: "extensionTraits",
                type: "string",
              },
            ],
            internalType: "struct Hound.Identity",
            name: "identity",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "string",
                name: "name",
                type: "string",
              },
              {
                internalType: "string",
                name: "token_uri",
                type: "string",
              },
              {
                internalType: "uint256",
                name: "runningOn",
                type: "uint256",
              },
              {
                internalType: "bool",
                name: "custom",
                type: "bool",
              },
            ],
            internalType: "struct Hound.Profile",
            name: "profile",
            type: "tuple",
          },
        ],
        internalType: "struct Hound.Struct",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "houndOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "hounds",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "staminaLastUpdate",
            type: "uint256",
          },
          {
            internalType: "uint32",
            name: "staminaValue",
            type: "uint32",
          },
        ],
        internalType: "struct Hound.Stamina",
        name: "stamina",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "lastBreed",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "externalBreedingFee",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "availableToBreed",
            type: "bool",
          },
        ],
        internalType: "struct Hound.Breeding",
        name: "breeding",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "maleParent",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "femaleParent",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "generation",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "birthDate",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "specie",
            type: "uint256",
          },
          {
            internalType: "uint32[72]",
            name: "geneticSequence",
            type: "uint32[72]",
          },
          {
            internalType: "string",
            name: "extensionTraits",
            type: "string",
          },
        ],
        internalType: "struct Hound.Identity",
        name: "identity",
        type: "tuple",
      },
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "token_uri",
            type: "string",
          },
          {
            internalType: "uint256",
            name: "runningOn",
            type: "uint256",
          },
          {
            internalType: "bool",
            name: "custom",
            type: "bool",
          },
        ],
        internalType: "struct Hound.Profile",
        name: "profile",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "id",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "matingSeason",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "renamingProposals",
    outputs: [
      {
        internalType: "string",
        name: "proposal",
        type: "string",
      },
      {
        internalType: "bool",
        name: "accepted",
        type: "bool",
      },
      {
        internalType: "bool",
        name: "sessionActive",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "string",
            name: "name",
            type: "string",
          },
          {
            internalType: "string",
            name: "symbol",
            type: "string",
          },
          {
            components: [
              {
                components: [
                  {
                    internalType: "uint256",
                    name: "staminaLastUpdate",
                    type: "uint256",
                  },
                  {
                    internalType: "uint32",
                    name: "staminaValue",
                    type: "uint32",
                  },
                ],
                internalType: "struct Hound.Stamina",
                name: "stamina",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "uint256",
                    name: "lastBreed",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "externalBreedingFee",
                    type: "uint256",
                  },
                  {
                    internalType: "bool",
                    name: "availableToBreed",
                    type: "bool",
                  },
                ],
                internalType: "struct Hound.Breeding",
                name: "breeding",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "uint256",
                    name: "maleParent",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "femaleParent",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "generation",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "birthDate",
                    type: "uint256",
                  },
                  {
                    internalType: "uint256",
                    name: "specie",
                    type: "uint256",
                  },
                  {
                    internalType: "uint32[72]",
                    name: "geneticSequence",
                    type: "uint32[72]",
                  },
                  {
                    internalType: "string",
                    name: "extensionTraits",
                    type: "string",
                  },
                ],
                internalType: "struct Hound.Identity",
                name: "identity",
                type: "tuple",
              },
              {
                components: [
                  {
                    internalType: "string",
                    name: "name",
                    type: "string",
                  },
                  {
                    internalType: "string",
                    name: "token_uri",
                    type: "string",
                  },
                  {
                    internalType: "uint256",
                    name: "runningOn",
                    type: "uint256",
                  },
                  {
                    internalType: "bool",
                    name: "custom",
                    type: "bool",
                  },
                ],
                internalType: "struct Hound.Profile",
                name: "profile",
                type: "tuple",
              },
            ],
            internalType: "struct Hound.Struct",
            name: "defaultHound",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "address",
                name: "externalBreedingFeeCurrency",
                type: "address",
              },
              {
                internalType: "address",
                name: "breedingCooldownCurrency",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "breedingCooldown",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "breedingCooldownTimeUnit",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "refillBreedingCooldownCost",
                type: "uint256",
              },
            ],
            internalType: "struct Hound.ConstructorBreeding",
            name: "breeding",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "address",
                name: "staminaRefillCurrency",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "staminaRefill1x",
                type: "uint256",
              },
              {
                internalType: "uint32",
                name: "staminaPerTimeUnit",
                type: "uint32",
              },
              {
                internalType: "uint32",
                name: "staminaCap",
                type: "uint32",
              },
            ],
            internalType: "struct Hound.ConstructorStamina",
            name: "stamina",
            type: "tuple",
          },
          {
            internalType: "address[]",
            name: "operators",
            type: "address[]",
          },
          {
            internalType: "bytes4[][]",
            name: "targets",
            type: "bytes4[][]",
          },
          {
            components: [
              {
                internalType: "address",
                name: "restricted",
                type: "address",
              },
              {
                internalType: "address",
                name: "minter",
                type: "address",
              },
              {
                internalType: "address",
                name: "houndsModifier",
                type: "address",
              },
              {
                internalType: "address",
                name: "zerocost",
                type: "address",
              },
              {
                internalType: "address",
                name: "hounds",
                type: "address",
              },
              {
                internalType: "address",
                name: "payments",
                type: "address",
              },
              {
                internalType: "address",
                name: "shop",
                type: "address",
              },
              {
                internalType: "address",
                name: "races",
                type: "address",
              },
              {
                internalType: "address",
                name: "genetics",
                type: "address",
              },
              {
                internalType: "address",
                name: "houndsInitializer",
                type: "address",
              },
              {
                internalType: "address",
                name: "houndsRenameHandler",
                type: "address",
              },
            ],
            internalType: "struct ConstructorBoilerplate.Struct",
            name: "boilerplate",
            type: "tuple",
          },
          {
            components: [
              {
                internalType: "address",
                name: "renameFeeCurrency",
                type: "address",
              },
              {
                internalType: "address",
                name: "platformBreedFeeCurrency",
                type: "address",
              },
              {
                internalType: "address",
                name: "breedTransactionFeeCurrency",
                type: "address",
              },
              {
                internalType: "uint256",
                name: "platformBreedFee",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "breedTransactionFee",
                type: "uint256",
              },
              {
                internalType: "uint256",
                name: "renameFee",
                type: "uint256",
              },
            ],
            internalType: "struct ConstructorFees.Struct",
            name: "fees",
            type: "tuple",
          },
        ],
        internalType: "struct Constructor.Struct",
        name: "globalParameters",
        type: "tuple",
      },
    ],
    name: "setGlobalParameters",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "_matingSeason",
        type: "bool",
      },
    ],
    name: "setMatingSeason",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "whitelists",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type HoundsMinterConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: HoundsMinterConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class HoundsMinter__factory extends ContractFactory {
  constructor(...args: HoundsMinterConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "HoundsMinter";
  }

  deploy(
    input: Constructor.StructStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<HoundsMinter> {
    return super.deploy(input, overrides || {}) as Promise<HoundsMinter>;
  }
  getDeployTransaction(
    input: Constructor.StructStruct,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(input, overrides || {});
  }
  attach(address: string): HoundsMinter {
    return super.attach(address) as HoundsMinter;
  }
  connect(signer: Signer): HoundsMinter__factory {
    return super.connect(signer) as HoundsMinter__factory;
  }
  static readonly contractName: "HoundsMinter";
  public readonly contractName: "HoundsMinter";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): HoundsMinterInterface {
    return new utils.Interface(_abi) as HoundsMinterInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): HoundsMinter {
    return new Contract(address, _abi, signerOrProvider) as HoundsMinter;
  }
}
